import React from 'react';
import './ReviewOnboardingSteps.css'; // We'll create this CSS file next
import { signal, effect } from "@preact/signals-react";
import { useTranslation } from 'react-i18next';

export const currentStepCreationAccount = signal(2);


const ReviewOnboardingSteps = () => {
    const { t } = useTranslation();

    function BtnClick(e, step) {
        e.preventDefault(e);
        currentStepCreationAccount.value = step
        console.log("currentStepCreationAccount", currentStepCreationAccount.value);
    }
    return (
        <div className="ReviewOnboardingSteps-container">
            <h2>{t('Onboarding')}</h2>

            <div className="onboarding-step completed">
                <div className="step-header">
                    <h3>{t("YourProfile")}</h3>
                    {/* <div className="progress-percentage">100%</div> */}
                </div>
                <label>{t('YourProfileValue')} </label>
                {/* <div className="progress-bar">
                    <div className="progress" style={{ width: '100%' }}></div>
                </div> */}
            </div>

            <div className="onboarding-step in-progress">
                <button className='ReviewBtnStep' onClick={(e) => BtnClick(e, 2)}>
                    <div className="step-header">
                        <h3>{t('IdentityProof')}</h3>
                        {/* <div className="progress-percentage">17%</div> */}
                    </div>
                    <label>{t('IdentityProofValue')}</label>
                    {/* <div className="progress-bar">
                        <div className="progress" style={{ width: '17%' }}></div>
                    </div> */}
                </button>
            </div>

            <div className="onboarding-step">
            <button className='ReviewBtnStep'  onClick={(e) => BtnClick(e, 3)}>
                    <div className="step-header">
                        <h3>{t('RiskProfile')}</h3>
                        {/* <div className="progress-percentage">0%</div> */}
                    </div>
                    <label>{t('RiskProfileValue')} </label>
                    {/* <div className="progress-bar">
                        <div className="progress" style={{ width: '0%' }}></div>
                    </div> */}
                </button>
            </div>

            <div className="onboarding-step">
            <button className='ReviewBtnStep'  onClick={(e) => BtnClick(e, 4)}>
                    <div className="step-header">
                        <h3>{t('ProductSuitability')} </h3>
                        {/* <div className="progress-percentage">0%</div> */}
                    </div>
                    <label>{t('ProductSuitabilityValue')}</label>
                    {/* <div className="progress-bar">
                        <div className="progress" style={{ width: '0%' }}></div>
                    </div> */}
                </button>
            </div>
        </div>
    );
};

export default ReviewOnboardingSteps;
